import React, { Component } from 'react';
import { planName } from '../../configs/plan';

export const required = value => value ? undefined : 'Required';

export const renderField = ({ input, label, type, className, placeholder, meta: { touched, error, warning } }) => (
    <div>
        <label>{label}</label>
        <div>
            <input {...input} type={type} className={className} placeholder={placeholder}/>
            {touched && ((error && <span className="error">{error}</span>) || (warning && <span>{warning}</span>))}
        </div>
    </div>
);

// Only support translation on PDA Gold.
export const __ = (text, domain) => {
	if ( ! wp.i18n || typeof wp.i18n.__ !== 'function' ) {
		return text;
	} else {
		if (planName === 'gold') {
			return wp.i18n.__(text, 'prevent-direct-access-gold');
		}
	}
	return text;
}

export const containsSpecialChar = (str) => {
    return /[~`!#$%\^@&*+=\(\)\[\]\\';,/{}|\\":<>\?]/g.test(str);
}

export const mustLargerThan0 = (n) => {
    return Number.parseInt(n) > 0;
}

export const validate = values => {
    const errors = {};
    const requiredFields = [ 'url' ];
    requiredFields.forEach(field => {
        if (!values[ field ]) {
            errors[ field ] = 'Required'
        }
        if (values[ field ] && values[ field ].indexOf(' ') >= 0) {
            errors[ field ] = 'Please remove spaces!';
        }
        if (values[ field ] && containsSpecialChar(values [field ])) {
            errors[ field ] = 'Please use characters, numbers, dash (-) and underscore (_) only to make your URLs user friendly.';
        }

    });

    const numberFields = [ 'limit_downloads' ];
    numberFields.forEach(field => {
        if ( values[ field ] && !mustLargerThan0(values [field] )) {
            errors[ field ] = 'Please enter a number greater than zero (0).';
        }
    });

    const validateExpired = [ 'expired_days' ];
    validateExpired.forEach(field => {
        if ( values[ field ] && !mustLargerThan0(values [field] )) {
            errors[ field ] = 'Please enter a number greater than zero (0).';
        }
    });

    const validateLimitDownloadPRU = [ 'private_link_user_limit_downloads' ];
    validateLimitDownloadPRU.forEach(field => {
        if ( values[ field ] && !mustLargerThan0(values [field] )) {
            errors[ field ] = 'Please enter a number greater than zero (0).';
        }
    });

    const validateExpiredPRU = [ 'private_link_user_expired_days' ];
    validateExpiredPRU.forEach(field => {
        if ( values[ field ] && !mustLargerThan0(values [field] )) {
            errors[ field ] = 'Please enter a number greater than zero (0).';
        }
    });

    if (values.email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
        errors.email = 'Invalid email address';
    }
    return errors;
}
